import { options } from '@carbon/charts/configuration';
import messages from '../locales/messages';
import { FormattedMessage } from 'react-intl';

export default {
  introduction: {
    title: <FormattedMessage {...messages.introTitle} />,
    copy: <FormattedMessage {...messages.introCopy} />,
    copy2: <FormattedMessage {...messages.intro2Copy} />,
    button: <FormattedMessage {...messages.introButton} />,
    imageSrc: 'images/landingpage.svg',
  },
  questions: [
    {
      id: 'q1',
      questionNumber: 1,
      type: 'single-option',
      title: <FormattedMessage {...messages.q1Title} />,
      imageSrc: 'images/imageq1.svg',
      resultType: `Strategy`,
      options: [
        {
          optionId: 'option-1-1',
          copy: <FormattedMessage {...messages.option1Q1} />,
          nextStep: 'q1a',
          value: 6,
        },
        {
          optionId: 'option-1-2',
          copy: <FormattedMessage {...messages.option2Q1} />,
          nextStep: 'q1a',
          value: 5,
        },
        {
          optionId: 'option-1-3',
          copy: <FormattedMessage {...messages.option3Q1} />,
          nextStep: 'q1a',
          value: 4,
        },
        {
          optionId: 'option-1-4',
          copy: <FormattedMessage {...messages.option4Q1} />,
          nextStep: 'q2',
          value: 3,
        },
        {
          optionId: 'option-1-5',
          copy: <FormattedMessage {...messages.option5Q1} />,
          nextStep: 'q2',
          value: 2,
        },
        {
          optionId: 'option-1-6',
          copy: <FormattedMessage {...messages.option6Q1} />,
          nextStep: 'q2',
          value: 1,
        },
      ],
    },
    {
      id: 'q1a',
      questionNumber: 1.1,
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q1aTitle} />,
      imageSrc: 'images/imageq1a.svg',
      resultType: `Strategy`,
      options: [
        {
          imageSrc: 'images/1_yes_black.svg',
          imageSelected: 'images/1_yes_color.svg',
          optionId: 'option-1.1-1',
          copy: <FormattedMessage {...messages.option1Q1a} />,
          text: 'yes',
          nextStep: 'q1b',
          value: 6,
        },
        {
          imageSrc: 'images/1_no_black.svg',
          imageSelected: 'images/1_no_color.svg',
          optionId: 'option-1.1-2',
          copy: <FormattedMessage {...messages.option2Q1a} />,
          text: 'no',
          nextStep: 'q2',
          value: 3,
        },
      ],
    },
    {
      id: 'q1b',
      questionNumber: 1.2,
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q1bTitle} />,
      imageSrc: 'images/imageq1b.svg',
      resultType: `Strategy`,
      options: [
        {
          imageSrc: 'images/1b_un_black.svg',
          imageSelected: 'images/1b_un_color.svg',
          optionId: 'option-1.2-1',
          copy: <FormattedMessage {...messages.option1Q1b} />,
          text: 'Uniform',
          nextStep: 'q2',
          value: 3,
        },
        {
          imageSrc: 'images/1b_dv_black.svg',
          imageSelected: 'images/1b_dv_color.svg',
          optionId: 'option-1.2-2',
          copy: <FormattedMessage {...messages.option2Q1b} />,
          text: 'Diversified',
          nextStep: 'q2',
          value: 3,
        },
      ],
    },
    {
      id: 'q2',
      questionNumber: 2,
      type: 'single-option',
      title: <FormattedMessage {...messages.q2Title} />,
      imageSrc: 'images/imageq2.svg',
      resultType: `Data`,
      options: [
        {
          optionId: 'option-2-1',
          copy: <FormattedMessage {...messages.option1Q2} />,
          nextStep: 'q3',
          value: 6,
        },
        {
          optionId: 'option-2-2',
          copy: <FormattedMessage {...messages.option2Q2} />,
          nextStep: 'q3',
          value: 4,
        },
        {
          optionId: 'option-2-3',
          copy: <FormattedMessage {...messages.option3Q2} />,
          nextStep: 'q3',
          value: 3,
        },
        {
          optionId: 'option-2-4',
          copy: <FormattedMessage {...messages.option4Q2} />,
          nextStep: 'q3',
          value: 2,
        },
        {
          optionId: 'option-2-5',
          copy: <FormattedMessage {...messages.option5Q2} />,
          nextStep: 'q3',
          value: 1,
        },
      ],
    },
    {
      id: 'q3',
      questionNumber: 3,
      type: 'single-option',
      title: <FormattedMessage {...messages.q3Title} />,
      imageSrc: 'images/imageq3.svg',
      resultType: `Strategy`,
      options: [
        {
          optionId: 'option-3-1',
          copy: <FormattedMessage {...messages.option1Q3} />,
          nextStep: 'q4',
          value: 6,
        },
        {
          optionId: 'option-3-2',
          copy: <FormattedMessage {...messages.option2Q3} />,
          nextStep: 'q4',
          value: 3,
        },
        {
          optionId: 'option-3-3',
          copy: <FormattedMessage {...messages.option3Q3} />,
          nextStep: 'q4',
          value: 2,
        },
        {
          optionId: 'option-3-4',
          copy: <FormattedMessage {...messages.option4Q3} />,
          nextStep: 'q4',
          value: 1,
        },
      ],
    },
    {
      id: 'q4',
      questionNumber: 4,
      type: 'slider',
      imageSrc: 'images/imageq4.svg',
      title: <FormattedMessage {...messages.q4Title} />,
      resultType: `Culture`,
      nextStep: 'q5',
      levels: [
        {
          levelId: 10,
          guidance: `Diversity and multidisciplinary efforts are crucial to
        approach AI responsibly. You need to double down on breaking the silos
        that prevent meaningful collaboration. In this way, a more diverse team
        can advocate for more rigorous data sets, design and implementation.`,
          copy: <FormattedMessage {...messages.option1Q4} />,
          value: 1,
        },
        {
          levelId: 20,
          guidance: `Your organization is on the right track. Diversity
          and multidisciplinary efforts are crucial to approach AI responsibly. In
          this way, a more diverse team can advocate for more rigorous data sets,
          design and implementation. Continue to drive this collaboration
          throughout the AI lifecycle.`,
          copy: <FormattedMessage {...messages.option1Q4} />,
          value: 3,
        },
        {
          levelId: 30,
          guidance: `Your organization is on the right track. Diversity
          and multidisciplinary efforts are crucial to approach AI responsibly. In
          this way, a more diverse team can advocate for more rigorous data sets,
          design and implementation. Continue to drive this collaboration
          throughout the AI lifecycle.`,
          copy: <FormattedMessage {...messages.option1Q4} />,
          value: 6,
        },
      ],
    },
    {
      id: 'q5',
      questionNumber: 5,
      type: 'single-option',
      title: <FormattedMessage {...messages.q5Title} />,
      imageSrc: 'images/imageq5.svg',
      resultType: `Strategy`,
      options: [
        {
          optionId: 'option-5-1',
          copy: <FormattedMessage {...messages.option1Q5} />,
          nextStep: 'q6',
          value: 1,
        },
        {
          optionId: 'option-5-2',
          copy: <FormattedMessage {...messages.option2Q5} />,
          nextStep: 'q6',
          value: 2,
        },
        {
          optionId: 'option-5-3',
          copy: <FormattedMessage {...messages.option3Q5} />,
          nextStep: 'q6',
          value: 4,
        },
        {
          optionId: 'option-5-4',
          copy: <FormattedMessage {...messages.option4Q5} />,
          nextStep: 'q6',
          value: 6,
        },
      ],
    },
    {
      id: 'q6',
      questionNumber: 6,
      type: 'single-option',
      title: <FormattedMessage {...messages.q6Title} />,
      imageSrc: 'images/imageq6.svg',
      resultType: `Culture`,
      options: [
        {
          optionId: 'option-6-1',
          copy: <FormattedMessage {...messages.option1Q6} />,
          nextStep: 'q7',
          value: 3,
        },
        {
          optionId: 'option-6-2',
          copy: <FormattedMessage {...messages.option2Q6} />,
          nextStep: 'q7',
          value: 6,
        },
        {
          optionId: 'option-6-3',
          copy: <FormattedMessage {...messages.option3Q6} />,
          nextStep: 'q7',
          value: 1,
        },
      ],
    },
    {
      id: 'q7',
      questionNumber: 7,
      type: 'single-option',
      title: <FormattedMessage {...messages.q7Title} />,
      imageSrc: 'images/imageq7.svg',
      resultType: `Culture`,
      options: [
        {
          optionId: 'option-7-1',
          copy: <FormattedMessage {...messages.option1Q7} />,
          nextStep: 'q8',
          value: 1,
        },
        {
          optionId: 'option-7-2',
          copy: <FormattedMessage {...messages.option2Q7} />,
          nextStep: 'q8',
          value: 2,
        },
        {
          optionId: 'option-7-3',
          copy: <FormattedMessage {...messages.option3Q7} />,
          nextStep: 'q8',
          value: 4,
        },
        {
          optionId: 'option-7-4',
          copy: <FormattedMessage {...messages.option4Q7} />,
          nextStep: 'q8',
          value: 6,
        },
      ],
    },
    {
      id: 'q8',
      questionNumber: 8,
      type: 'single-option',
      title: <FormattedMessage {...messages.q8Title} />,
      imageSrc: 'images/imageq8.svg',
      resultType: `Data`,
      options: [
        {
          optionId: 'option-8-1',
          copy: <FormattedMessage {...messages.option1Q8} />,
          nextStep: 'q9',
          value: 1,
        },
        {
          optionId: 'option-8-2',
          copy: <FormattedMessage {...messages.option2Q8} />,
          nextStep: 'q9',
          value: 4,
        },
        {
          optionId: 'option-8-3',
          copy: <FormattedMessage {...messages.option3Q8} />,
          nextStep: 'q9',
          value: 6,
        },
      ],
    },
    {
      id: 'q9',
      questionNumber: 9,
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q9Title} />,
      imageSrc: 'images/imageq9.svg',
      resultType: `Strategy`,
      options: [
        {
          imageSrc: 'images/9_yes_black.svg',
          imageSelected: 'images/9_yes_color.svg',
          optionId: 'option-9-1',
          copy: <FormattedMessage {...messages.option1Q9} />,
          text: 'yes',
          nextStep: 'success',
          value: 6,
        },
        {
          imageSrc: 'images/9_no_black.svg',
          imageSelected: 'images/9_no_color.svg',
          optionId: 'option-9-2',
          copy: <FormattedMessage {...messages.option2Q9} />,
          text: 'no',
          nextStep: 'success',
          value: 3,
        },
      ],
    },
  ],
  success: {
    title: <FormattedMessage {...messages.successTitle} />,
    copy: <FormattedMessage {...messages.successCopy} />,
    buttonBack: <FormattedMessage {...messages.successButtonBack} />,
    buttonResults: <FormattedMessage {...messages.successButtonResults} />,
    imageSrc: 'images/successImage.svg',
  },
  results: {
    resultsTitle: <FormattedMessage {...messages.resultsTitle} />,
    resultsCopy: <FormattedMessage {...messages.resultsCopy} />,
    imageSrc: 'images/results.svg',
    logoGovernance: 'image/governance.svg',
    logoData: 'image/data.svg',
    logoCulture: 'image/culture.svg',
    summaryCopy: <FormattedMessage {...messages.summaryCopy} />,
    summaryLinksTitle: <FormattedMessage {...messages.summaryLinksTitle} />,
    summaryLink1: <FormattedMessage {...messages.summaryLink1} />,
    summaryLink2: <FormattedMessage {...messages.summaryLink2} />,
    summaryLink3: <FormattedMessage {...messages.summaryLink3} />,
    summarySpeakToExpert: (
      <FormattedMessage {...messages.summarySpeakToExpert} />
    ),
    summarySpeakToExpertButton: (
      <FormattedMessage {...messages.summarySpeakToExpertButton} />
    ),
    governanceLabel: <FormattedMessage {...messages.governanceLabel} />,
    forensicLabel: <FormattedMessage {...messages.forensicLabel} />,
    cultureLabel: <FormattedMessage {...messages.cultureLabel} />,
    buttonSave: <FormattedMessage {...messages.buttonSave} />,
    buttonRestart: <FormattedMessage {...messages.buttonRestart} />,
    graphicStrategy: <FormattedMessage {...messages.graphicStrategy} />,
    graphicData: <FormattedMessage {...messages.graphicData} />,
    graphicPeople: <FormattedMessage {...messages.graphicPeople} />,
    graphicCaption: <FormattedMessage {...messages.graphicCaption} />,
    summaryLabel: <FormattedMessage {...messages.summaryLabel} />,
    summaryScroll: <FormattedMessage {...messages.summaryScroll} />,
    minRecomendation: <FormattedMessage {...messages.minRecomendation} />,
    mediumRecomendation: <FormattedMessage {...messages.mediumRecomendation} />,
    maxRecomendation: <FormattedMessage {...messages.maxRecomendation} />,
  },
};
